export default __webpack_public_path__ + "static/media/office-open-space.8044f709.jpg";